import {
    AccessorsMutatorsDecorator
} from '../../helpers';
import {
    Model
} from '../../helpers';
import {
    TranslatableModel
} from './translatable-model';

/**
 * @class RegistrationCard
 * @property {number} id
 */
export class RegistrationCard extends TranslatableModel {

    formatTermsConditions(value = this.terms_conditions) {

        return this.trustAsHTML(value);
    }

    formatTermsConditionsAr(value = this.terms_conditions_ar) {

        return this.trustAsHTML(value);
    }

    formatFooter(value = this.footer) {

        return this.trustAsHTML(value);
    }

    formatFooterAr(value = this.footer_ar) {

        return this.trustAsHTML(value);
    }

    trustAsHTML(value = '') {

        return this.constructor.$sce.trustAsHtml(value);
    }

    static get translatableAttributes() {

        return ['fields', 'terms_conditions', 'footer'];
    }

    static get fieldsLocales() {

        return {
            firstName: {
                en: "First Name",
                ar: 'الاسم الاول'
            },

            lastName: {
                en: "Last Name",
                ar: 'الكنية'
            },
            country: {
                en: "Country",
                ar: 'بلد'
            },
            city: {
                en: "City",
                ar: 'مدينة'
            },
            cellPhone: {
                en: "Cell Phone",
                ar: "الهاتف الخلوي"
            },
            "Customer Type": {
                en: "Customer Type",
                ar: "نوع العميل"
            },
            "Cell Phone": {
                en: "Cell Phone",
                ar: "الهاتف الخلوي"
            },
            "Email": {
                en: "Email",
                ar: "البريد الإلكتروني"
            },
            "Room Number": {
                en: "Room Number",
                ar: "رقم الغرفة"
            },
            "Number of nights": {
                en: "Number of nights",
                ar: "عدد الليالي"
            },
            "Check in date": {
                en: "Check in date",
                ar: "تاريخ الوصول"
            },
            "Check out date": {
                en: "Check out date",
                ar: "موعد انتهاء الأقامة"
            },
            "Number of guests": {
                en: "Number of guests",
                ar: "عدد الضيوف"
            },
            "Nationality": {
                en: "Nationality",
                ar: "جنسية"
            },
            "ID Type": {
                en: "ID Type",
                ar: "نوع المعرف"
            },
            "ID Number": {
                en: "ID Number",
                ar: "رقم التعريف"
            },
            "ID Serial": {
                en: "ID Serial#",
                ar: "معرف المسلسل #"
            },
            "Visa Number": {
                en: "Visa Number",
                ar: "رقم الفيزا"
            },
            "Issue Place": {
                en: "Issue Place",
                ar: "مكان القضية"
            },
            "Address": {
                en: "Address",
                ar: "عنوان"
            },
            "Work Place": {
                en: "Work Place",
                ar: "مكان العمل"
            },
            "Work Phone": {
                en: "Work Phone",
                ar: "هاتف عمل"
            },
            "Company Name": {
                en: "Company Name",
                ar: "اسم الشركة"
            },
            "CR Number": {
                en: "CR Number",
                ar: "رقم السجل التجاري"
            },
            "Company Phone": {
                en: "Company Phone",
                ar: "هاتف الشركة"
            },
            "Guest Status": {
                en: "Guest Status (Guest Category)",
                ar: "حالة الضيف (فئة الضيف)"
            },
            "Reservation Number": {
                en: "Reservation Number",
                ar: "رقم الحجز"
            },
            "Confirmation Number": {
                en: "Third Party Confirmation Number",
                ar: "رقم تأكيد الطرف الثالث"
            },
            "Adults": {
                en: "Adults",
                ar: "الكبار"
            },
            "Children": {
                en: "Children",
                ar: "الأطفال"
            },
            "Room Type": {
                en: "Room Type",
                ar: "نوع الغرفة"
            },
            "Accommodation Total": {
                en: "Accommodation Total",
                ar: "الإقامة المجموع"
            },
            "Amount Paid": {
                en: "Amount Paid",
                ar: "المبلغ المدفوع"
            },
            "Grand Total": {
                en: "Grand Total",
                ar: "المبلغ الإجمالي"
            },
            "Deposit": {
                en: "Deposit",
                ar: "الوديعة"
            },
            "Products": {
                en: "Products (Additional Items)",
                ar: "المنتجات (عناصر إضافية)"
            },
            "Balance Due": {
                en: "Balance Due",
                ar: "الرصيد المستحق"
            },
            "Credit Card Type": {
                en: "Credit Card Type",
                ar: "نوع بطاقة الائتمان"
            },
            "Reservation Date": {
                en: "Reservation Date",
                ar: "تاريخ الحجز"
            },
            "Source": {
                en: "Source",
                ar: "مصدر"
            },
            "Cancellation Date": {
                en: "Cancellation Date",
                ar: "تاريخ الإلغاء"
            },
            "Estimated Arrival Time": {
                en: "Estimated Arrival Time",
                ar: "الوقت المتوقع للوصول"
            },


        }
    }

    static get availableFields() {

        return {
            items: [{
                    code: 'firstName',
                    type: 'item'
                },
                {
                    code: 'lastName',
                    type: 'item'
                },
                {
                    code: 'country',
                    type: 'item'
                },
                {
                    code: 'city',
                    type: 'item'
                },
                {
                    code: "Customer Type",
                    type: 'item'
                },
                {
                    code: "Cell Phone",
                    type: 'item'
                },
                {
                    code: "Email",
                    type: 'item'
                },
                {
                    code: "Room Number",
                    type: 'item'
                },
                {
                    code: "Number of nights",
                    type: 'item'
                },
                {
                    code: "Check in date",
                    type: 'item'
                },
                {
                    code: "Check out date",
                    type: 'item'
                },
                {
                    code: "Number of guests",
                    type: 'item'
                },
                {
                    code: "Nationality",
                    type: 'item'
                },
                {
                    code: "ID Type",
                    type: 'item'
                },
                {
                    code: "ID Number",
                    type: 'item'
                },
                {
                    code: "ID Serial",
                    type: 'item'
                },
                {
                    code: "Visa Number",
                    type: 'item'
                },
                {
                    code: "Issue Place",
                    type: 'item'
                },
                {
                    code: "Address",
                    type: 'item'
                },
                {
                    code: "Work Place",
                    type: 'item'
                },
                {
                    code: "Work Phone",
                    type: 'item'
                },
                {
                    code: "Company Name",
                    type: 'item'
                },
                {
                    code: "CR Number",
                    type: 'item'
                },
                {
                    code: "Company Phone",
                    type: 'item'
                },
                {
                    code: "Guest Status",
                    type: 'item',
                },
                {
                    code: "Reservation Number",
                    type: 'item'
                },
                {
                    code: "Confirmation Number",
                    type: 'item'
                },
                {
                    code: "Adults",
                    type: 'item'
                },
                {
                    code: "Children",
                    type: 'item'
                },
                {
                    code: "Room Type",
                    type: 'item'
                },
                {
                    code: "Accommodation Total",
                    type: 'item'
                },
                {
                    code: "Amount Paid",
                    type: 'item'
                },
                {
                    code: "Grand Total",
                    type: 'item'
                },
                {
                    code: "Deposit",
                    type: 'item'
                },
                {
                    code: "Products",
                    type: 'item'
                },
                {
                    code: "Balance Due",
                    type: 'item'
                },
                {
                    code: "Credit Card Type",
                    type: 'item'
                },
                {
                    code: "Reservation Date",
                    type: 'item'
                },
                {
                    code: "Source",
                    type: 'item'
                },
                {
                    code: "Cancellation Date",
                    type: 'item'
                },
                {
                    code: "Estimated Arrival Time",
                    type: 'item'
                }
            ]
        }
    }
}

AccessorsMutatorsDecorator(
    'id',
    'language',
    'property_id',
    'every_page_footer',
    ...RegistrationCard.translatableAttributesWithLanguageAliases
)(RegistrationCard);


// WEBPACK FOOTER //
// ./src/pms-api/models/registration-card.model.js